module.exports = __webpack_public_path__ + "img/icon-less.eaf74e15.svg";